import { useMemo } from 'react';
import useInvoiceScanManager from 'src/hooks/useInvoiceScanManager';
import useSplitter from 'src/hooks/useSplitter';
import InvoicePreviewSection from './InvoicePreviewSection';
import InvoiceScanManagerTab from './InvoiceScanManagerTab';

const InvoiceScanManagerSplitter = () => {
  const { showPrev, previewDocument, isHidePreview } = useInvoiceScanManager();

  const PreviewSection = useMemo(
    () => (previewDocument ? <InvoicePreviewSection /> : <></>),

    [previewDocument]
  );

  const FullPage = useSplitter(
    <InvoiceScanManagerTab />,
    PreviewSection,
    isHidePreview ? false : showPrev
  );

  return FullPage;
};
export default InvoiceScanManagerSplitter;
